import { useCallback } from 'react';

import { IconPound } from '@iwoca/icons';
import { Input, Label, Tooltip } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';

import { TCompanyDetailsDataUK } from './CompanyDetailsUK';
import companyDetailsStyles from './CompanyDetailsUK.module.css';

const TurnoverInputUK = () => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<TCompanyDetailsDataUK>();

  const formatCurrency = useCallback(() => {
    const amount = watch('last12MonthsTurnover')?.replace(/[^0-9]+/g, '');
    if (!amount) return '';

    return parseInt(amount).toLocaleString('en-GB');
  }, [watch]);

  return (
    <>
      <div className={companyDetailsStyles.formLabel}>
        <Label htmlFor="last12MonthsTurnover">Last 12 months’ turnover</Label>
        <Tooltip content="If you have been trading for less than a year, enter your total turnover to date." />
      </div>
      <Input
        {...register('last12MonthsTurnover')}
        value={formatCurrency()}
        placeholder="Any amount"
        id={'last12MonthsTurnover'}
        type="text"
        iconLeft={<IconPound />}
        error={
          errors?.last12MonthsTurnover?.message &&
          errors.last12MonthsTurnover.message
        }
      />
    </>
  );
};

export default TurnoverInputUK;
